// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"44cde09f","977":"5b25647d"}[chunkId] + ".chunk.js";
};